import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Keyboard, ScreenShare, Assignment, BallotRounded, WatchOutlined } from "@material-ui/icons";
import { formatMessage, MainMenuContribution, withModulesManager } from "@openimis/fe-core";

const CLAIM_MAIN_MENU_CONTRIBUTION_KEY = "claim.MainMenu";

class ClaimMainMenu extends Component {
  render() {
    const { rights, modulesManager, intl } = this.props;
    const entries = [];

    // 1. Health Facility Claims
    entries.push({
      text: formatMessage(intl, "claim", "menu.healthFacilityClaims"),
      icon: <Keyboard />,
      route: "/claim/healthFacilities",
      id: "claimMenu.healthFacilities",
    });

    // 2. Encounter Claims
    entries.push({
      text: formatMessage(intl, "claim", "menu.encounterClaims"),
      icon: <Keyboard />,
      route: "/claim/encounters",
      id: "claimMenu.encounters",
    });

    // 4. Reviews
    entries.push({
      text: formatMessage(intl, "claim", "menu.reviews"),
      icon: <Assignment />,
      route: "/claim/reviews",
      id: "claimMenu.reviews",
    });

    // 5. Preauthorization
    entries.push({
      text: formatMessage(intl, "claim", "menu.preauthorization"),
      icon: <BallotRounded />,
      route: "/preauthorization/preauthorization",
      id: "claimMenu.preauthorization",
    });

    // Add contributions from other modules (if any)
    const contribs = modulesManager.getContribs(CLAIM_MAIN_MENU_CONTRIBUTION_KEY);
    entries.push(...contribs.filter((c) => !c.filter || c.filter(rights)));

    if (!entries.length) return null;

    return (
      <MainMenuContribution
        {...this.props}
        header={formatMessage(intl, "claim", "mainMenu")}
        icon={<ScreenShare />}
        entries={entries}
        menuId="ClaimMainMenu" // Unique ID for the menu
      />
    );
  }
}

const mapStateToProps = (state) => ({
  rights: state?.core?.user?.i_user?.rights || [],
});

export default withModulesManager(injectIntl(connect(mapStateToProps)(ClaimMainMenu)));
